import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule, Http, RequestOptions, XHRBackend } from '@angular/http';
import { RouterModule, UrlSerializer, PreloadAllModules } from '@angular/router';

//Modules
import { SharedModule } from './shared/shared.module';
import { ModalModule } from "ngx-bootstrap";
//Providers
import { App } from './app.component';
import { LowerCaseUrlSerializer, httpServiceFunction, FMSBaseRequestOptions } from './shared/services/http-utilities.service';

// Routes
import { AppModuleRouting } from './app.routes';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TimepickerModule, PaginationModule, TypeaheadModule } from 'ngx-bootstrap';

@NgModule({
    imports: [
        HttpModule,
        CommonModule,
        RouterModule,
        BrowserAnimationsModule,
        ModalModule,
        AppModuleRouting,

        SharedModule.forRoot(),
        PaginationModule.forRoot(),
        TimepickerModule.forRoot(),
        TypeaheadModule.forRoot()
    ],
    declarations: [
        App
    ],
    providers: [
        {
            provide: UrlSerializer,
            useClass: LowerCaseUrlSerializer
        },
        {
            provide: Http,
            useFactory: httpServiceFunction,
            deps: [XHRBackend, RequestOptions]
        },
        {
            provide: RequestOptions,
            useClass: FMSBaseRequestOptions
        }
    ],
    bootstrap: [App]
})
export class AppModule { }


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/app.module.ts